import _ from 'lodash'
import wAxios from '@/plugins/w/axios/models/axios'
import { buildQueryFilters, createApiHook } from '@/plugins/app/api'

export interface MaterialOrdersFilters {
	search?: string
	state?: string
	range?: {
		start: string
		end: string
	}
	access_id?: string
}

export const QUERY_KEY = 'material-order'

export const DEFAULT_FILTERS: MaterialOrdersFilters = {
	search: '',
	state: 'ordered',
	range: {
		start: '',
		end: ''
	},
	access_id: ''
}

export const fetchFn = async (pagination: Pagination, filters: MaterialOrdersFilters = {}) => {
	const query = fetchQuery(pagination, filters)
	return wAxios.post_auth(`v2/collection-material-orders`, query).catch((error) => Promise.reject(error.response || error))
}

export const fetchQuery = (pagination: Pagination, filters: MaterialOrdersFilters) => {
	const filtersWithDefaults = _.defaults(filters, DEFAULT_FILTERS)
	let offset = pagination.per_page * (pagination.current_page ? pagination.current_page - 1 : 0)

	const query = {
		orderState: filtersWithDefaults.state ? filtersWithDefaults.state.toUpperCase() : '',
		limit: pagination.per_page.toString(),
		offset: String(offset),
		search: filtersWithDefaults.search || '',
		dateFrom: filtersWithDefaults.range?.start || '',
		dateUntil: filtersWithDefaults.range?.end || '',
		access_id: filtersWithDefaults.access_id || ''
	}

	return query
}

export const useGetMaterialOrders = createApiHook(fetchFn, QUERY_KEY, fetchQuery)

export const deleteDraftMaterialOrders = async (orders: { id: number }[]) => {
	return wAxios
		.delete_auth(`v1/collection-material-orders`, { data: { orders } })
		.catch((error) => Promise.reject(error.response || error))
}
